



















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { save, load } from "@/helpers/storage";
const log = NSLog("view/Home");

@Component({
  components: {
    loader
  }
})
export default class DataSourcesFilter extends Vue {
  @Prop() public value: any;
  @Prop() public filter: any;

  public created() {
    if (this.value) {
      this.$emit('input', this.value);
    }
  }

  @debounce(500, { leading: false })
  public update(ev: any) {
    this.$emit("input", ev);
  }
}
